import { Dimensions, Platform } from "react-native";

export const palette = {
  common: {
    black: "#000000",
    disabled: "#B0B0B0",
    gray: "#C4C4C4",
    grayBackground: "#F6F6F6",
    green: "#34A853",
    lightGray: "#EDEDED",
    lightGreen: "#73F3A8",
    mediumGray: "#B0B0B0",
    overlay: "rgba(0, 0, 0, 0.3)",
    transparent: "transparent",
    white: "#FFFFFF",
    whiteTransparent: "#FFFFFF00",
    lightPaleViolet: "#DDDDFF",
    paleViolet: "#CCCCFE",
    pinkSalmon: "#FDE9E9",
    burgundy: "#8E2B46",
    wrongPink: "#FADCE5",
  },
  primary: {
    accentLight: "#68649c",
    accentDark: "#32325D",
    accent: "#000054",
    loader: "rgba(154, 155, 165, 0.4)",
    main: "#F49090",
    mainLight: "#FDF7F6",
    mainChat: "#FCDEDE",
    pinkSalmon: "#F49090",
    turquoise: "#019A93",
    lightTurquoise: "#B3E1DF",
    purple: "#A50CDB",
    lightPurple: "#D3C0ED",
    green: "#33a854",
  },
  secondary: {
    accent: "#EB507B",
    main: "#F4F4F4",
    green: "#90E2AC",
    lightGreen: "#bfe2c9",
    grey: "#DADADB",
    lightGrey: "#E5E5EE",
    wrongPink: "#E8527B",
    butter: "#FEE4AE",
    pink: "#FF94B1",
    lightPink: "#F5E8F9",
    pinkSalmon: "#DD7373",
  },
  accent: {
    main: "#F8703E",
  },
  tertiary: {
    accent: "#F49090",
    main: "#F4F4F4",
    green: "#306141",
  },
  font: {
    error: "#E8527B",
    placeholder: "#C4C4C4",
    primary: "#000000",
    secondary: "#666666",
  },
  worker: {
    error: "#CD1A4C",
  },
} as const;

const { width, height } = Dimensions.get("window");
const unit = 8;

export const spacing = {
  unit: unit,
  radius: unit * 1.25,
  border: unit / 8,
  minTouchableSize: Platform.select({ default: unit * 6, ios: unit * 5.5 }),

  deviceWidth: Platform.select({ default: width, web: Math.min(1024, width) }),
  deviceHeight: height,
  headerHeight: unit * 10,
  isBigScreen: width > height,
};

export const gradientPoint = {
  primary: [
    { offset: "0%", stopOpacity: 1, stopColor: "#0101A6" },
    { offset: "100%", stopOpacity: 1, stopColor: "#000050" },
  ],
  salmon: [
    { offset: "0%", stopOpacity: 1, stopColor: "#FFA6A6" },
    { offset: "100%", stopOpacity: 1, stopColor: "#E66767" },
  ],
  pink: [
    { offset: "0%", stopOpacity: 1, stopColor: "#FC8FAC" },
    { offset: "100%", stopOpacity: 1, stopColor: "#D9486D" },
  ],
  green: [
    { offset: "0%", stopOpacity: 1, stopColor: "#7FF396" },
    { offset: "100%", stopOpacity: 1, stopColor: "#429351" },
  ],
  purple: [
    { offset: "0%", stopOpacity: 1, stopColor: "#A47FEF" },
    { offset: "100%", stopOpacity: 1, stopColor: "#6B3BD1" },
  ],
  cobalt: [
    { offset: "0%", stopOpacity: 1, stopColor: "#4646F4" },
    { offset: "100%", stopOpacity: 1, stopColor: "#0B0BB6" },
  ],
};
